import styles from './index.module.less';
import template from './index.art';
import { IOYFilterBarChannelProps, IOYFilterBarChannelState } from "./const";
import OY from '../../../../types/OY';
import { EEventType } from '../../../../enums/EEventType';
import { jeact } from '../../../../decorators/jeact';

@jeact()
export default class OYFilterBarChannel extends OY<IOYFilterBarChannelProps, IOYFilterBarChannelState> {
  static displayName = 'OYFilterBarChannel';

  static defaultProps: Partial<IOYFilterBarChannelProps> = {
    data: [],
    dropdownOffset: 0
  };

  state: IOYFilterBarChannelState = {
    name: ''
  }

  $node = {
    icon: $()
  }

  getDerivedStateFromProps(nextProps: IOYFilterBarChannelProps, state: IOYFilterBarChannelState) {
    const { data, value } = nextProps;
    let { name } = state;
    if (value) {
      const result = data.find(va => va.value === value);
      if (result) {
        name = result.name;
      }
    }
    return { ...state, name };
  }

  render() {
    return template({ props: this.props, state: this.state, styles });
  }

  setNode() {
    this.$node = {
      icon: this.$el.find(`.${styles.icon}`)
    }
  }

  bindNameClick() {
    this.$el.find(`.${styles.name}`).click((event: Event) => {
      event.stopPropagation();
      this.$el.toggleClass(styles.active);
      if (this.$el.hasClass(styles.active)) {
        this.handlebindDocument();
      }
    })
  }

  bindItemClick() {
    this.$el.find(`.${styles.item}`).click((event: Event) => {
      event.stopPropagation();
      const $elment = $(event.currentTarget!);
      const index = $elment.data('index');
      const data = this.props.data[index];
      if (data.value !== this.props.value) {
        this.eventEmitter.emit(EEventType.onClick, this.props.data[index], index)
        this.$el.removeClass(styles.active);
      }
    })
  }

  handlebindDocument() {
    $(document).on('click', this.handleDocumentClick.bind(this));
  }

  handleDocumentClick() {
    this.$el.removeClass(styles.active);
    $(document).off('click', this.handleDocumentClick)
  }
}



// WEBPACK FOOTER //
// ./src/components/OYFilterBar/components/OYFilterBarChannel/index.ts